<template>
  <v-layout wrap>
    <v-card-title v-if="isImplementedTemplateName">
      <v-icon left>info</v-icon> Form Information
    </v-card-title>
    <v-flex v-if="value == externalLink" pa-2>
      <p>
        External link icons can be specified in the icon field. The full list of available icons <a href="https://material.io/resources/icons/?style=baseline" target="_blank">can be found here</a>
      </p>
    </v-flex>
    <v-divider v-if="isImplementedTemplateName" />
  </v-layout>
</template>

<script>
  const externalLink = 'External Link'
  export default {
    props: {
      value: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        externalLink,
        implementedTemplateNames: [
          externalLink,
        ],
      }
    },
    computed: {
      isImplementedTemplateName() {
        return this.implementedTemplateNames.map(x => x.toLowerCase()).includes(this.value.toLowerCase())
      },
    },
  }
</script>